(function ($) {
  $(window).on('load', function () {
    initPhotoSwipeFromDOM('.gallery');
    var resizeId;

    function doneResizing() {
      $('.gallery.grid-h').GridHorizontal({
        item: '.item',
        minWidth: 350,
        maxRowHeight: 220,
        gutter: 20,
      });
    }
    doneResizing();
    $(window).resize(function () {
      clearTimeout(resizeId);
      resizeId = setTimeout(doneResizing, 500);
    });
  });
})($);